import React from 'react';
import VBox from '../../components/layout/VBox';
import Markdown from '../chat/Markdown';
import styles from './page.module.css';

const PoliticaDpoPage = () => {
    return (
        <VBox style={{ padding: '2rem', maxWidth: '1200px', margin: '0 auto' }}>
            <Markdown className={styles.container} value={`
# ENCARREGADO DE DADOS (DPO) – TERACHAT

**Última atualização:** 09/09/2026

Em conformidade com a Lei Geral de Proteção de Dados (LGPD – Lei nº 13.709/2018, art. 41), a **Terachat** designou um Encarregado de Proteção de Dados (DPO) responsável por atuar como canal de comunicação entre a empresa, os titulares de dados e a Autoridade Nacional de Proteção de Dados (ANPD).

---

## 1. Atribuições do Encarregado

O Encarregado é responsável por:
- Aceitar reclamações e comunicações dos titulares e prestar esclarecimentos;
- Orientar funcionários e colaboradores sobre as práticas de proteção de dados;
- Executar as demais atribuições previstas no art. 41 da LGPD e em regulamentações da ANPD.

---

## 2. Papéis na LGPD

- **Cliente (Controlador):** titular da relação com os usuários finais e responsável pelas decisões sobre o tratamento de seus dados;
- **Terachat (Operadora):** trata dados conforme as instruções do Cliente.

**Importante:** solicitações de exercício de direitos (acesso, correção, exclusão, portabilidade, etc.) referentes a dados de atendimentos devem ser dirigidas diretamente ao **Cliente** (ex.: empresa com a qual o titular se relacionou). A Terachat, como operadora, prestará o apoio técnico necessário.

---

## 3. Como Contatar o Encarregado

Dúvidas sobre esta política, sobre o tratamento de dados realizado pela Terachat ou sobre proteção de dados pessoais em geral devem ser encaminhadas para:

**E-mail:** daniel.lobo@terachat.com.br

O retorno será dado em prazo compatível com a natureza da solicitação e conforme os prazos previstos na legislação aplicável.

---

## 4. Base Legal e Alterações

Esta designação e os contatos aqui informados podem ser atualizados periodicamente. A versão vigente estará sempre disponível na plataforma ou site da Terachat.
`} />
        </VBox>
    );
};

export default PoliticaDpoPage;